import React, { Component } from "react"
import classnames from "classnames"
import { ContextLayout } from "../../../../utility/context/Layout"
import { connect } from "react-redux"
import SidebarHeader from "./SidebarHeader"
import Hammer from "react-hammerjs"
import SideMenuContent from "./sidemenu/SideMenuContent"
import PerfectScrollbar from "react-perfect-scrollbar"
import {HiOutlineSupport} from "react-icons/hi";
import {Spinner, Button, ModalHeader, Modal, ModalBody, ListGroup, ListGroupItem} from "reactstrap";
import {history} from "../../../../history";
import {FormattedMessage} from "react-intl";
import {fireDb} from "../../../../authServices/firebase/firebaseConfig";
import {activeEventId} from "../../../../App";
import HelpModal from "./HelpModal";

class Sidebar extends Component {
  eventId = activeEventId
  static getDerivedStateFromProps(props, state) {
    if (props.activePath !== state.activeItem) {
      return {
        activeItem: props.activePath
      }
    }
    // Return null if the state hasn't changed
    return null
  }
  state = {
    width: window.innerWidth,
    activeIndex: null,
    hoveredMenuItem: null,
    activeItem: this.props.activePath,
    menuShadow: false,
    ScrollbarTag: PerfectScrollbar,
    left_navigation_banner: "",
    left_navigation_banner_loading: true,
    helpModal: false
  }

  mounted = false

  constructor(props) {
    super(props);
    this.loadLeftNavigationBanner()
    this.helpModalHandler = this.helpModalHandler.bind(this)
  }

  loadLeftNavigationBanner = () => {
    fireDb.collection("banners")
      .where("event_id", "==", this.eventId)
      .where("type", "==", "left_navigation")
      .where("hidden", "==", false)
      .get()
      .then(snap => {
        if(snap.docs.length) {
          let i = 0
          snap.forEach(item => {
            i++
            if(i===1)
            {
              let data = item.data()
              this.setState({left_navigation_banner:data.image||"",
                left_navigation_banner_link: data.url||"",
                left_navigation_banner_loading:false})
            }
          })
        } else {
          this.setState({left_navigation_banner_loading:false})
        }
      }).catch((error) => {this.setState({left_navigation_banner_loading:false})})
  }

  updateWidth = () => {
    if (this.mounted) {
      this.setState(prevState => ({
        width: window.innerWidth
      }))
      this.checkDevice()
    }
  }

  componentDidMount() {
    this.mounted = true
    if (this.mounted) {
      if (window !== "undefined") {
        window.addEventListener("resize", this.updateWidth, false)
      }
      this.checkDevice()
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  checkDevice = () => {
    var prefixes = " -webkit- -moz- -o- -ms- ".split(" ")
    var mq = function(query) {
      return window.matchMedia(query).matches
    }

    if ("ontouchstart" in window || window.DocumentTouch) {
      this.setState({
        ScrollbarTag: "div"
      })
    } else {
      this.setState({
        ScrollbarTag: PerfectScrollbar
      })
    }
    var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("")
    return mq(query)
  }

  changeActiveIndex = id => {
    if (id !== this.state.activeIndex) {
      this.setState({
        activeIndex: id
      })
    } else {
      this.setState({
        activeIndex: null
      })
    }
  }

  handleSidebarMouseEnter = id => {
    if (id !== this.state.hoveredMenuItem) {
      this.setState({
        hoveredMenuItem: id
      })
    } else {
      this.setState({
        hoveredMenuItem: null
      })
    }
  }

  handleActiveItem = url => {
    this.setState({
      activeItem: url
    })
  }

  helpModalHandler = () => {
    this.setState({helpModal: !this.state.helpModal})
  }

  render() {
    let {
      visibilityState,
      toggleSidebarMenu,
      sidebarHover,
      toggle,
      color,
      sidebarVisibility,
      activeTheme,
      collapsed,
      activePath,
      sidebarState,
      currentLang,
      permission,
      currentUser,
      collapsedMenuPaths
    } = this.props

    let {
      menuShadow,
      activeIndex,
      hoveredMenuItem,
      activeItem,
      ScrollbarTag,
      left_navigation_banner,
      left_navigation_banner_link,
      left_navigation_banner_loading
    } = this.state
    let scrollShadow = (container, dir) => {
      if (container && dir === "up" && container.scrollTop >= 100) {
        this.setState({ menuShadow: true })
      } else if (container && dir === "down" && container.scrollTop < 100) {
        this.setState({ menuShadow: false })
      } else {
        return
      }
    }
    return (
      <ContextLayout.Consumer>
        {context => {
          let dir = context.state.direction
          return (
            <React.Fragment>
              <Hammer
                onSwipe={e => {
                  sidebarVisibility()
                }}
                direction={
                  dir === "rtl" ? "DIRECTION_LEFT" : "DIRECTION_RIGHT"
                }>
                <div className="menu-swipe-area d-xl-none d-block vh-100"></div>
              </Hammer>

              <div
                className={classnames(
                  `main-menu menu-fixed menu-light menu-accordion menu-shadow theme-${activeTheme}`,
                  {
                    collapsed: sidebarState === true,
                    "hide-sidebar": this.state.width < 1200 && visibilityState === false
                  }
                )}
                onMouseEnter={() => sidebarHover(false)}
                onMouseLeave={() => sidebarHover(true)}>
                <SidebarHeader
                  toggleSidebarMenu={toggleSidebarMenu}
                  toggle={toggle}
                  sidebarBgColor={color}
                  sidebarVisibility={sidebarVisibility}
                  activeTheme={activeTheme}
                  collapsed={collapsed}
                  menuShadow={menuShadow}
                  activePath={activePath}
                  sidebarState={sidebarState}
                />
                <ScrollbarTag
                  className={classnames("main-menu-content", {
                    "overflow-hidden": ScrollbarTag !== "div",
                    "overflow-scroll": ScrollbarTag === "div"
                  })}
                  {...(ScrollbarTag !== "div" && {
                    options: { wheelPropagation: false },
                    onScrollDown: container => scrollShadow(container, "down"),
                    onScrollUp: container => scrollShadow(container, "up"),
                    onYReachStart: () =>
                      menuShadow === true &&
                      this.setState({ menuShadow: false })
                  })}>
                  <Hammer
                    onSwipe={() => {
                      sidebarVisibility()
                    }}
                    direction={
                      dir === "rtl" ? "DIRECTION_RIGHT" : "DIRECTION_LEFT"
                    }>
                    <ul className="navigation navigation-main">
                      <SideMenuContent
                        setActiveIndex={this.changeActiveIndex}
                        activeIndex={activeIndex}
                        hoverIndex={hoveredMenuItem}
                        // handleSidebarMouseEnter={this.handleSidebarMouseEnter}
                        handleSidebarMouseEnter={() => {}}
                        activeItemState={activeItem}
                        handleActiveItem={this.handleActiveItem}
                        activePath={activePath}
                        lang={currentLang}
                        permission={permission}
                        currentUser={currentUser}
                        collapsedMenuPaths={collapsedMenuPaths}
                        toggleMenu={sidebarVisibility}
                        deviceWidth={this.props.deviceWidth}
                      />
                      <div className={"text-center"}>
                      {left_navigation_banner_loading ? <Spinner className={"mt-3"} color={"white"} size={"sm"} /> : left_navigation_banner && <li className={"sidebarBanner text-center"}>
                        <a href={left_navigation_banner_link} rel={"noopener noreferrer"} target={"_blank"}><img className={"rounded"} src={left_navigation_banner} width={175} /></a>
                      </li>}
                      </div>
                      <Modal size={"lg"} isOpen={this.state.helpModal} toggle={this.helpModalHandler}>
                        <ModalHeader toggle={this.helpModalHandler}><FormattedMessage id={"main.needASupport"} /></ModalHeader>
                        <ModalBody>
                          <HelpModal close={() => {
                            this.helpModalHandler()
                          }} />
                        </ModalBody>
                      </Modal>
                      <li className={"support-li"}>
                        <Button
                          onClick={this.helpModalHandler}
                          color={"success"} className={"support-button pl10px pr10px pt5px pb5px"} id={"support"}>
                          <HiOutlineSupport size={24} color={"primary"} className={"mr10px"} />
                          <FormattedMessage id={"main.needASupport"} />
                        </Button>
                      </li>
                    </ul>
                  </Hammer>
                </ScrollbarTag>
              </div>
            </React.Fragment>
          )
        }}
      </ContextLayout.Consumer>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.auth.login.userRole
  }
}

export default connect(mapStateToProps)(Sidebar)
